import { ConfigurationError } from '@cian/peperrors/shared';
import * as React from 'react';

interface IOfferHoverApi {
  setHoveredOfferId(id: number): void;
  resetHoveredOfferId(): void;
}

// Два контекста: команды (api) отделены от значения, чтобы писатели наведения не ререндерились при смене hoveredOfferId
const OfferHoverStateContext = React.createContext<number | null>(null);
const OfferHoverApiContext = React.createContext<IOfferHoverApi | null>(null);
OfferHoverStateContext.displayName = 'OfferHoverStateContext';
OfferHoverApiContext.displayName = 'OfferHoverApiContext';

export const OfferHoverProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [hoveredOfferId, setHoveredOfferId] = React.useState<number | null>(null);

  const resetHoveredOfferId = React.useCallback(() => setHoveredOfferId(null), []);

  const api = React.useMemo<IOfferHoverApi>(() => ({ setHoveredOfferId, resetHoveredOfferId }), [resetHoveredOfferId]);

  return (
    <OfferHoverApiContext.Provider value={api}>
      <OfferHoverStateContext.Provider value={hoveredOfferId}>{children}</OfferHoverStateContext.Provider>
    </OfferHoverApiContext.Provider>
  );
};

export function useOfferHoverApi(): IOfferHoverApi {
  const context = React.useContext(OfferHoverApiContext);

  if (!context) {
    throw new ConfigurationError({
      message: 'useOfferHoverApi used outside of OfferHoverProvider',
      domain: 'OfferHoverContext',
    });
  }

  return context;
}

export function useHoveredOfferId(): number | null {
  return React.useContext(OfferHoverStateContext);
}
